import type { LucideIcon } from "lucide-react";

export interface SegmentedItem<Value extends string> {
  value: Value;
  label: string;
  icon?: LucideIcon;
  count?: number;
}

export function SegmentedControl<Value extends string>({
  value,
  items,
  onChange,
  label,
  compact = false,
  className = "",
}: {
  value: Value;
  items: SegmentedItem<Value>[];
  onChange: (value: Value) => void;
  label: string;
  compact?: boolean;
  className?: string;
}) {
  return (
    <div
      className={`segmented-control ${compact ? "segmented-control--compact" : ""} ${className}`.trim()}
      role="tablist"
      aria-label={label}
    >
      {items.map((item) => {
        const Icon = item.icon;
        const selected = item.value === value;
        return (
          <button
            type="button"
            role="tab"
            aria-selected={selected}
            className={selected ? "is-active" : ""}
            key={item.value}
            onClick={() => onChange(item.value)}
          >
            {Icon && <Icon aria-hidden="true" />}
            <span>{item.label}</span>
            {item.count !== undefined && <b>{item.count}</b>}
          </button>
        );
      })}
    </div>
  );
}
